export default __webpack_public_path__ + "static/media/description_4.75ac54cc.svg";